<template>
  <div class="page-grid-wrapper">
    <h2 v-if="AreIdsShown">WidgetSummaryMeasuresContainer</h2>

    <h4 v-if="AreIdsShown" style="color: red">DashMeasuresRecordSelector</h4>

    <DashMeasuresRecordSelector idField="id" :fields="fieldsRecordsArray" :key="userStore.lsbTheme" :records="filteredMeasures()" :providerNameList="providerNameList" />
  </div>
</template>

<script setup>
import { ref, onMounted, watch } from "vue";

// * STOREs
import { useStoreUser } from "@/stores/userStore";
const userStore = useStoreUser();
// * STOREs
import { useStoreWorkList } from "@/stores/workListsStore";
const workListStore = useStoreWorkList();

import DashMeasuresRecordSelector from "@/views/Dashboard/DashMeasuresRecordSelector.vue";

const AreIdsShown = ref(false);
const measures = ref([]);
const componentKey = ref(0);
const providerNameList = ref([]);

const fieldsRecordsArray = ref([
  // 'id',
  // 'contractMeasureID',
  "contractMeasureName",
  "eligible",
  "neededForTarget",
  "target",
  "actualYTD",
  // 'rolling12Month',
  // 'priorYTD',
  "incompleteCnt",
  // 'neededForTarget',
  "completedCnt",
  "providerName",
  // 'measureStatus',
]);

async function loadMeasures() {
  await getPatientMeasuresCall();

  // Get provider list
  providerNameList.value = [];

  measures.value.forEach((r) => {
    // // // console.log(' 0 ')
    // // // console.log(' 0 r.providerName < '+ r.providerName)
    providerNameList.value.push(r.providerName);
  });
  // measures.value = allMyMeasures
  // console.log("provider lIst ");
  // console.log(providerNameList.value);

  // // console.log('NEW SET')

  providerNameList.value = [...new Set(workListStore.getContractMeasuresFilters.providerNamesList)];

  // console.log([...new Set(providerNameList.value)])
  // console.log(providerNameList.value);

  // providerNameList.value.forEach((name) => {
  // 	// // console.log(' name : ' + name)
  // 	this.searchTerms.push(name)
  // 	// // console.log(this.searchTerms)
  // })

  // // console.log(workListStore.getContractMeasuresFilters.providerName)

  // // // console.log('ForCe ReRender oN loadMeasures')
  // this.forceRerender()
}

function filteredMeasures() {
  // console.clear()
  //
  // console.log('MeasuresContainer oN filteredMeasures')
  // this.forceRerender()

  const uProviderName = workListStore.getContractMeasuresFilters.providerName;
  const uProviderNameList = workListStore.getContractMeasuresFilters.providerNamesList;

  const uFilter = workListStore.getContractMeasuresFilters.useCurrentStatusFilter;
  const uShowAllMeasures = workListStore.getContractMeasuresFilters.showAllMeasures;
  const uShowCompletedPatients = workListStore.getContractMeasuresFilters.showAllMeasuresCompletedPatients;

  const uShowStatusComplete = workListStore.getContractMeasuresFilters.isMeasuresStatusComplete;

  // console.log("	filteredMeasures :  uProviderName: ", uProviderName);
  // console.log("filteredMeasures :  uProviderNameList: ", uProviderNameList);

  // console.log("*************************************allMyMeasures *************************************************************************");
  const fPTest2 = workListStore.allMyMeasures.filter(function (person) {
    // console.dir(person)
    // // console.log('_____________')
    if (uShowAllMeasures) {
      return person.providerName;
    } else if (!uShowAllMeasures) {
      if (uFilter === "Y") {
        if (uProviderName !== null) {
          // // console.log(' PrvName :  ' + person.providerName)
          return person.providerName === uProviderName;
        }
      }
    }
  });
  const fPTestCOMPLETE = fPTest2.filter(function (person) {
    // console.dir(person)
    // console.log('___new filter __________')
    if (uShowAllMeasures) {
      return person.providerName;
    } else if (!uShowAllMeasures) {
      if (uFilter === "Y") {
        // // console.log('this.$store.state[workLists].measuresFilters.isMeasuresStatusComplete')
        // // console.log(this.$store.state['workLists'].measuresFilters.isMeasuresStatusComplete)
        // this.$store.commit('toggleMeasuresStatusComplete')

        if (uShowStatusComplete) {
          // console.log(' uShowStatusComplete :  ' + person.measureStatus)
          return person.measureStatus !== "3";
        } else {
          return person.measureStatus;
        }
      }
    }
  });

  // * ADD SWITCH
  // console.log('   ADD SWITCH  ForCe ReRender oN filteredMeasures        OFF')
  // this.forceRerender()

  // this.$store.commit('addONe')
  // this.$store.commit('addMyWorkFilterTaskStatusCount', fPTest.length)
  // // // console.log(fPTest)
  // console.log("FILTERED allMyMeasures  return fPTestCOMPLETE");
  // console.log(fPTestCOMPLETE);
  return fPTestCOMPLETE;

  // return workListStore.allMyMeasures
}
async function getPatientMeasuresCall() {
  // if (this.allMyMeasures.length <= 0) {
  // //// console.clear()()
  // // console.log(' ......................... 	getPatientMeasuresCall  ')
  // console.log("   GOING TO Worklist STOREs API call   await this.getAllMyMeasuresStoreToAPI()");
  const response = await workListStore.getAllMyMeasuresStoreToAPI();
  // console.log(" ......................... 	response  ");
  // console.log(response);
  // // console.log(' ......................... 	response  ')

  if (response.ok) {
    // // console.log('			......................OK')
    // // console.log('MEASURES filling >' + '  PatientId = ' + this.patientId)

    // STORE  STORE -->
    // // console.log('	# >>> SETTING  ......this.measures = response.payload.records...........')

    measures.value = workListStore.allMyMeasures;

    // Get provider list
    providerNameList.value = [];

    measures.value.forEach((r) => {
      // // // console.log(' 0 ')
      // // // console.log(' 0 r.providerName < '+ r.providerName)
      providerNameList.value.push(r.providerName);
    });
    // this.measures = allMyMeasures
    // // console.log('provider lIst ')
    // // console.log(this.providerNameList)

    // // console.log('NEW SET')

    providerNameList.value = [...new Set(workListStore.getContractMeasuresFilters.providerNamesList)];

    // console.log([...new Set(providerNameList.value)]);
    // console.log(providerNameList.value);
    // console.log("____________________________________________________________________((((((((((((");

    // this.providerNameList.forEach((name) => {
    // 	// // console.log(' name : ' + name)
    // 	this.searchTerms.push(name)
    // 	// // console.log(this.searchTerms)
    // })

    // // console.log(this.getContractMeasuresFilters.providerName)

    // this.measures = []
    // // console.dir(this.allMyMeasures)
    // console.log("          >>>>>>>>>>      measures.value");
    // console.dir(measures.value);

    return measures.value;
  }
  // }
  // else {dark
  // 	return this.measures = this.allMyMeasures
  // }
}

onMounted(() => {
  // console.log("onMounted() :      WidgetSummaryMeasuresContainer >>>>");
  // console.log(" FROM created()                          loadMeasures()");

  loadMeasures();
});

// Watch for changes to userStore.lsbTheme
watch(
  () => userStore.lsbTheme,
  (newTheme, oldTheme) => {
    // console.log("lsbTheme changed from", oldTheme, "to", newTheme);
    // You can trigger any logic here, e.g. reload data, update UI, etc.
    // Example: componentKey.value++; // to force re-render if needed
    // componentKey.value += 1;
  }
);
</script>

<style lang="scss" scoped>
.page-grid-wrapper {
  background-color: transparent !important; // #b0c1b283;

  width: 100%;
  padding: 0px;
  height: 100%;
  max-height: 71vh;
  //  height: 87vh;
  overflow-y: auto;
  overflow: hidden;
}

.card {
  border: 3px solid transparent !important;
  /* padding: 15px; */
  border-radius: 5px;
  background-color: #39464344 !important;
  width: 100% !important;
}

.card-img,
.card-img-top,
.card-img-bottom {
  height: 222px;
  flex-shrink: 0;
  width: 100%;
}
</style>
